// layout/OLTLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import DeviceHeader from "./DeviceHeader";
import DeviceNavigation from "./DeviceNavigation";
import "../styles/layout.css";

const OLTLayout = () => {
  return (
    <div className="olt-layout-container">
      <DeviceHeader />
      <div className="olt-layout-body">
        <DeviceNavigation />
        <main className="olt-content-area">
          {/* Outlet Component renders sub-pages (DashboardHome, ONU, Pon, etc.) */}
          <Outlet /> 
        </main>
      </div>
    </div>
  );
};

export default OLTLayout;